module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/shared/promos/2025/blackfridaysale/345x215/1.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/shared/promos/2025/blackfridaysale/345x215/1.png
// module id = /QtU
// module chunks = 0